import "./Footer.css";

function Footer() {
  return (
    <footer className="footerContent">
      <p id="footerText">Site desenvolvido por </p>
      <p>
        <a
          href="https://www.linkedin.com/in/beatriz-lages-melga%C3%A7o-036553218/"
          target="_blank"
        >
          Beatriz Lages Melgaço
        </a>
      </p>
    </footer>
  );
}

export default Footer;
